module.exports = __webpack_public_path__ + "img/slide12.1bba52d5.png";